import React from "react";
import { Card, CardBody, Row, Table } from "reactstrap";
import Skeleton from "react-loading-skeleton";

const LeadSnapshotLoading = () => {

    return (
        <React.Fragment>
            <Card>
                <CardBody className="py-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                <tbody>
                                    <tr>
                                        <td className="h4 font-weight-semibold text-black">
                                            <Skeleton />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Skeleton />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <Skeleton />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <Skeleton />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <Skeleton />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <Skeleton />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <Skeleton />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <Skeleton />
                                            </div>
                                        </td>
                                    </tr>
                                    <div>
                                        <div>
                                            <Skeleton />
                                        </div>
                                    </div>
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadSnapshotLoading